import { render, staticRenderFns } from "./Singularity.vue?vue&type=template&id=6acf2f32&"
import script from "./Singularity.vue?vue&type=script&lang=ts&"
export * from "./Singularity.vue?vue&type=script&lang=ts&"
import style0 from "./Singularity.vue?vue&type=style&index=0&id=6acf2f32&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports